import 'whatwg-fetch'; // IE10 Polyfill
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'; //IE Polyfill

export default function(url, options = {}) {
    let controller = new AbortController();
    let signal = controller.signal;

    let headers = undefined;
    if(options.method === 'POST' || options.body){
        headers = {
            'X-Requested-With' : 'XMLHttpRequest',
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            ...options.headers
        }
    }else{
        headers = {
            'X-Requested-With' : 'XMLHttpRequest',
            ...options.headers
        }
    }

    let pendingRequest = fetch(url, {
        method: options.body ? 'POST' : 'GET',
        signal: signal,
        ...options,
        headers
    });

    pendingRequest.abort = function () {
        controller.abort();
        pendingRequest = null;
    };
    pendingRequest.controller = controller;
    pendingRequest.signal = signal;

    return pendingRequest;
}







